import { render, staticRenderFns } from "./RemoteAttention.vue?vue&type=template&id=5a7c3a7d&scoped=true&"
import script from "./RemoteAttention.vue?vue&type=script&lang=js&"
export * from "./RemoteAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c3a7d",
  null
  
)

export default component.exports